import { styled } from 'ui/theme';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
